import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './Unauthorized.scss';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // This goes back to the previous page in the history stack
  };

  const handleGoHome = () => {
    navigate('/'); // This navigates to the home page
  };

  return (
    <div className="unauthorized-container">
      <h2>401 - Unauthorized</h2>
      <p>You do not have permission to view this page.</p>
      <div className="buttons">
        <Button variant="primary" onClick={handleGoBack}>Go Back</Button>
        <Button variant="secondary" onClick={handleGoHome}>Go Home</Button>
      </div>
    </div>
  );
};

export default Unauthorized;
